/// <amd-module name="Test/StackTraceParser/StackTraceLinkCreator" />
import {
    ILinkedStackTraceInfo,
    IParsedStackTraceInfo,
    ISourceInfoProvider,
    IStackTraceLinkCreatorService
} from "Test/StackTraceParser/Contracts";
import { Services, VssService } from "VSS/Platform/Context";

export class StackTraceLinkCreatorService extends VssService implements IStackTraceLinkCreatorService {
    public createLinks(sourceInfoProvider: ISourceInfoProvider, parsedStackTraceInfo: IParsedStackTraceInfo[]): Promise<ILinkedStackTraceInfo[]> {

        return new Promise<ILinkedStackTraceInfo[]>((resolve, reject) => {
            if (sourceInfoProvider) {
              sourceInfoProvider
                .constructFilePath(parsedStackTraceInfo)
                .then((result: ILinkedStackTraceInfo[]) => {
                  resolve(result);
                });
            } else {
              let linkedStackTraceInfo: ILinkedStackTraceInfo[] = [];
              linkedStackTraceInfo = parsedStackTraceInfo.map(
                (parsedInfo: IParsedStackTraceInfo) => {
                  return {
                    stackTrace: parsedInfo.stackTrace,
                    url: ""
                  } as ILinkedStackTraceInfo;
                }
              );

              resolve(linkedStackTraceInfo);
            }
        });
    }
}

Services.add("IStackTraceLinkCreatorService", {serviceFactory: StackTraceLinkCreatorService});
